import Vue from 'vue'
import Vuex from 'vuex'
import common from './common'
import order from './order'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
	modules: {
		common,
		order
	},
	strict: debug
})

store.registerModule('vux', { // 名字自己定义
	state: {
		isLoading: false
	},
	mutations: {
		updateLoadingStatus (state, payload) {
			state.isLoading = payload.isLoading
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js